import { API, apiConfig, ROUTES } from "../../utils/api.url";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
import router from "@/router";
import { toastDispatch } from "@/assets/composables/toast-dispatch";
import { useRouter } from 'vue-router'
import { getCookie, deleteCookie } from '../../utils/cookies'
export default {
	namespaced: true,
	state: {
		user: [],
		notifications: [],
		profile_notifications: [],
		referrals: [],
	},
	mutations: {
		SET_DATA(state, data) {
			state.user = data;
		},
		SET_NOTIFICATIONS(state, data) {
			state.notifications = data;
		},
		SET_PROFILE_NOTIFICATIONS(state, data) {
			state.profile_notifications = data.slice(0, 10);
		},
		SET_REFERRALS(state, data) {
			state.referrals = data;
		},
	},
	actions: {
		async register({}, payload) {
			let result = await API.post(ROUTES().register, payload)
				.then((res) => {
					toast.success(`${res.data.message}`);
					localStorage.setItem("email", res.data.data.user.email);
					router.push({ name: "email-message" });
				})
				.catch((err) => {
					toast.error(`${err.response.data.message}`);
				});

			return result;
		},
		async login({ dispatch }, payload) {
			const rout = useRouter()
			
			let result = await API.post(ROUTES().login, payload)
				.then((res) => {
					localStorage.setItem("token", res.data.data.token);
					let verified = res.data.data.user.email_verified;

					if (verified === true) {
						const link = getCookie("redirectTo");
						if(link){
							router.push(link)
						} else {
							toast.success(`${res.data.message}`);
							router.push({ name: "index" });
						}
						deleteCookie("redirectTo");
					} else {
						localStorage.setItem("email", res.data.data.user.email);
						dispatch("resendlink");
						router.push({ name: "email-message" });
					}
				})
				.catch((err) => {
					if (err.response) {
						toast.error(`${err.response.data.error}`);
					}
				});
            	
			return result;
		},
		async resendlink({}) {
			let result = await API.post(ROUTES().resendemaillink, {}, apiConfig())
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response) {
						toast.error(`${err.response.data.error}`);
					}
				});

			return result;
		},
		async verifyemail({}, payload) {
			let result = await API.post(ROUTES().verifyemail, payload)
				.then((res) => {
					toast.success(`${res.data.message}`);
					setTimeout(() => {
						router.push({ name: "login" });
					}, 2000);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					}
					if (err.response && err.response.data.error === "Email already verified") {
						setTimeout(() => {
							router.push({ name: "login" });
						}, 2000);
					} else if (err.response.data.message) {
						toast.error(`${err.response.data.message}`);
					}
				});
			return result;
		},
		async passwordResetLink({}, payload) {
			let result = await API.post(ROUTES().passwordresetlink, payload)
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});
			return result;
		},
		async resetPassword({}, payload) {
			let result = await API.post(ROUTES().resetpassword, payload)
				.then((res) => {
					toast.success(`${res.data.message}`);
					router.push({ name: "login" });
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});
			return result;
		},
		async getUser({ commit }) {
			let result = await API.get(ROUTES().authuser, apiConfig())
				.then((res) => {
					commit("SET_DATA", res.data.data);
					localStorage.setItem("user", JSON.stringify(res.data.data));
				})
				.then(() => {
					const user = localStorage.getItem("user");

					// window.fcWidget.init({
					// 	token: "5de4ac7b-7760-49df-97ff-77f623ba8650",
					// 	host: "https://wchat.freshchat.com",
					// 	externalId: user.email,
					// 	firstName: user.name,
					// 	email: user.email,
					// });
				})
				.catch(() => {
					router.push({ name: "login" });
				});
			return result;
		},
		async getNotifications({ commit }) {
			let result = await API.get(ROUTES().notifications, apiConfig()).then(
				(res) => {
					commit("SET_NOTIFICATIONS", res.data.data);
					commit("SET_PROFILE_NOTIFICATIONS", res.data.data);
				}
			);
			return result;
		},
		async showNotification({ dispatch }, id) {
			let result = await API.get(
				`${ROUTES().notifications}/${id}/show`,
				apiConfig()
			)
				.then((res) => {
					dispatch("getNotifications");
				})
				.catch((err) => {});
			return result;
		},
		async markAllAsRead({}) {
			let result = await API.get(
				`${ROUTES().notifications}/mark-all-as-read`,
				apiConfig()
			)
				.then((res) => {
					toastDispatch(res, "success");
				})
				.catch((err) => {
					console.log(err);
				});
			return result;
		},
		async getReferrals({ commit }) {
			let result = await API.get(ROUTES().referrals, apiConfig())
				.then((res) => {
					commit("SET_REFERRALS", res.data.data);
				})
				.catch((err) => {
					console.log(err);
				});
			return result;
		},
	},
	getters: {
		user(state) {
			return state.user;
		},
		notifications(state) {
			return state.notifications;
		},
		profile_notifications(state) {
			return state.profile_notifications;
		},
		referrals(state) {
			return state.referrals;
		},
	},
};
